import React from 'react';
import useRequireAuthorize from 'hook/auth/useRequireAuthorize';

const RequireRouteEnable = <P extends object>(WrappedComponent: React.ComponentType<P>, path: string) => {
  return (props: P) => {
    useRequireAuthorize(path);

    return <WrappedComponent {...props} />;
  };
};

export default RequireRouteEnable;
